<template>
  <div style="background-color: #F1F4FB;">
    <div class="px-4 mx-auto py-10 sm:max-w-xl md:max-w-full lg:max-w-screen-xl sm:px-6 md:px-8 lg:px-10">
      <div class="py-5">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }" class="myColor">EMHUB</el-breadcrumb-item>
          <el-breadcrumb-item>联系我们</el-breadcrumb-item>
        </el-breadcrumb>

        <!--        <div class="my-32">-->
        <!--          北京朝阳区光华路1号嘉里中心北楼405  电话+86（10）8529 6181 联系人Mia Liu-->
        <!--        </div>-->
        <!--        <div class="my-32">-->
        <!--          欧洲医疗服务中心北京办事处  电话+86（10）8529 6181 联系人Mia Liu-->
        <!--        </div>-->
        <div class="mt-10 mb-32">
          <div class="bg-white relative flex flex-wrap py-6 px-6 rounded shadow-md">

            <div class="lg:w-1/2 ">
              <h2 class="title-font font-bold text-gray-900 tracking-widest text-base">欧洲医疗服务中心北京办事处</h2>
              <p class=" text-gray-400">&nbsp;</p>
            </div>
            <div class="lg:w-1/2 mt-4 lg:mt-0"></div>
            <div class="border-b-2 lg:w-full border-black mb-6" style="border-bottom-color: #EEEEEE;"></div>

            <div class="lg:w-1/2 mt-4 lg:mt-0">
              <h2 class="title-font text-gray-900 tracking-widest text-sm ">联系人</h2>
              <p class="text-gray-400 text-sm">Rachel.You</p>
              <h2 class="title-font text-gray-900 tracking-widest text-sm mt-4">电话</h2>
              <p class=" text-gray-400 text-sm">+86（10）8529 6181</p>
            </div>
            <div class="lg:w-1/2 mt-4 lg:mt-0">
              <h2 class="title-font text-gray-900 tracking-widest text-sm ">邮箱</h2>
              <p class=" text-gray-400 text-sm">info@emhub.com.cn</p>
              <h2 class="title-font text-gray-900 tracking-widest text-sm mt-4">地址</h2>
              <p class="text-gray-400 text-sm">北京朝阳区光华路1号嘉里中心北楼405</p>
            </div>

          </div>
        </div>


      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "supportService"
  }
</script>

<style scoped>
  .myColor /deep/ .el-breadcrumb__inner {
    color: #123B7F;
  }

  .myColor>>>.el-breadcrumb__inner:hover {
    color: #123B7F;
  }
</style>